import { render } from "./PayPalReturn.vue?vue&type=template&id=5654d122&scoped=true"
import script from "./PayPalReturn.vue?vue&type=script&lang=js"
export * from "./PayPalReturn.vue?vue&type=script&lang=js"

import "./PayPalReturn.vue?vue&type=style&index=0&id=5654d122&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5654d122"]])

export default __exports__